import { render, staticRenderFns } from "./PayerResourceLogins.vue?vue&type=template&id=145bc70a&scoped=true&"
import script from "./PayerResourceLogins.vue?vue&type=script&lang=js&"
export * from "./PayerResourceLogins.vue?vue&type=script&lang=js&"
import style0 from "./PayerResourceLogins.vue?vue&type=style&index=0&id=145bc70a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145bc70a",
  null
  
)

export default component.exports